import { emptySplitApi } from './index'

export const projectFundersApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
        getAllProjectFunders: builder.mutation({
            query: (model) => ({
                url: `api/v1/project-service/project-funders?`
                    + `pageNumber=${model?.pageNumber || 0}`
                    + `&pageSize=${model?.pageSize || ''}`
                    + `&orderField=${model?.orderField || 'userName'}`
                    + `&orderDirection=${model?.orderDirection || 'asc'}`
                    + `&userProjectId=${model?.userProjectId}`
                    + `&letterType=${model?.letterType}`
                    + `&withCustomDocument=${false}`,
                method: "GET"
            }),
        }),
        getAllProjectFundersCustomDocument: builder.mutation({
            query: (model) => ({
                url: `api/v1/project-service/project-funders?`
                    + `pageNumber=${model?.pageNumber || 0}`
                    + `&pageSize=${model?.pageSize || ''}`
                    + `&orderField=${model?.orderField || 'userName'}`
                    + `&orderDirection=${model?.orderDirection || 'asc'}`
                    + `&userProjectId=${model?.userProjectId}`
                    + `&letterType=${model?.letterType}`
                    + `&flagFilter=${model?.flagFilter}`
                    + `&withCustomDocument=${true}`,
                method: "GET"
            }),
        }),
        getAllProjectFundersDocument: builder.mutation({
            query: (model) => ({
                url: `api/v1/project-service/project-funders/v2?`
                    + `pageNumber=${model?.pageNumber || 0}`
                    + `&pageSize=${model?.pageSize || ''}`
                    + `&orderField=${model?.orderField || 'userName'}`
                    + `&orderDirection=${model?.orderDirection || 'asc'}`
                    + `&userProjectId=${model?.userProjectId}`
                    + `&flagFilter=${model?.flagFilter}`
                    + `&documentType=${model?.documentType || 'All'}`
                    + `&foundationStatus=${model?.foundationStatus || 'All'}`
                    + `&foundationname=${model?.foundationName || ''}`,
                method: "GET"
            }),
        }),
        getProjectFundersList: builder.mutation({
            query: ({ userProjectId }) => ({
                url:  `api/v1/project-service/project-funders/list/${userProjectId}`,
                method: "GET"
            })
        }),
        // Lean, cached-by-userProjectId funder list for the Quick Qualification queue (no flag/notes/
        // application enrichment) - avoids re-fetching and re-enriching the whole project on every Prev/Next.
        getProjectFundersQueue: builder.query({
            query: (userProjectId) => ({
                url: `api/v1/project-service/project-funders/queue/${userProjectId}`,
                method: "GET",
            }),
            providesTags: (result, error, userProjectId) => [{ type: "ProjectFundersQueue", id: userProjectId }],
        }),
        getFunderProjects: builder.mutation({
            query: (model) => ({
                url:  `api/v1/project-service/project-funders/funder-projects?`
                    + `funderId=${model.funderId}`
                    + `&currentProjectId=${model.currentProjectId}`,
                method: "GET",
            }),
        }),
        insertProjectFunders: builder.mutation({
            query: (model) => ({
                url: `api/v1/project-service/project-funders`,
                method: "POST",
                body: model
            }),
            invalidatesTags: ["ProjectFundersProfileId", "FoundationTimeline"],
        }),
        getAllProjectFundersProfileId: builder.mutation({
            query: (userProjectId) => ({
                url: `api/v1/project-service/project-funders/${userProjectId}`,
                method: "GET",
            }),
        }),
        getAllProjectFundersProfileId2: builder.query({
            query: (userProjectId) => ({
                url: `api/v1/project-service/project-funders/${userProjectId}`,
                method: "GET",
            }),
            providesTags: ['ProjectFundersProfileId'],
        }),
        insertFunderToProjects: builder.mutation({
            query: (model) => ({
                url: `api/v1/project-service/project-funders/projects`,
                method: "POST",
                body: model
            }),
        }),
        getProjectFundersCustomDocument: builder.mutation({
            query: ({userProjectId, letterType}) => ({
                url: `api/v1/project-service/project-funders/custom-document/${userProjectId}/${letterType}`,
                method: "POST"
            }),
        }),
        getProfileDetailsByProfileIdList: builder.mutation({
            query: (model) => ({
                url: `api/v1/project-service/project-funders/profile-details-list`,
                method: "POST",
                body: model
            }),
        }),
        updateFlag: builder.mutation({
            query: (model) => ({
                url: `api/v1/project-service/project-funders/flag-update`,
                method: "POST",
                body: model
            }),
        }),
        bulkUpdateFlag: builder.mutation({
            query: (model) => ({
                url: `api/v1/project-service/project-funders/bulk-flag-update`,
                method: "POST",
                body: model
            }),
        }),
        removeManyProjectFunders: builder.mutation({
            query: ({ userProjectId, profileIdList }) => ({
                url: `api/v1/project-service/project-funders/remove-many/${userProjectId}`,
                method: "DELETE",
                body: [...profileIdList]
            }),
            invalidatesTags: (result, error, { userProjectId }) => [{ type: "ProjectFundersQueue", id: userProjectId }],
        }),
        removeCurrentFundersFromOtherProjects: builder.mutation({
            query: (model) => ({
                url: `api/v1/project-service/project-funders/remove-from-projects`,
                method: "DELETE",
                body: model
            }),
        }),
        removeFundersFromProjects: builder.mutation({
            query: (model) => ({
                url: `api/v1/project-service/project-funders/remove-funders-from-projects`,
                method: "DELETE",
                body: model
            }),
        }),

    }),
  overrideExisting: false,
});

export const { 
    useGetAllProjectFundersMutation,
    useGetAllProjectFundersCustomDocumentMutation,
    useGetProjectFundersListMutation,
    useGetProjectFundersQueueQuery,
    useGetFunderProjectsMutation,
    useInsertProjectFundersMutation,
    useGetAllProjectFundersProfileIdMutation,
    useInsertFunderToProjectsMutation,
    useGetProjectFundersCustomDocumentMutation,
    useGetProfileDetailsByProfileIdListMutation,
    useUpdateFlagMutation,
    useBulkUpdateFlagMutation,
    useRemoveManyProjectFundersMutation,
    useRemoveCurrentFundersFromOtherProjectsMutation,
    useRemoveFundersFromProjectsMutation,
    useGetAllProjectFundersDocumentMutation,
    useGetAllProjectFundersProfileId2Query,
} = projectFundersApi;
